import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";

const HelpRequests = ({ helpRequests, setSelectedImage, HandleUpdateIsResolved }) => {
  return (
    <div>
      {helpRequests && helpRequests.map((req) => (
        <Card key={req.id} className="mb-4 shadow-sm">
          <Card.Header>
            <strong>#ID: {req.id}</strong>
          </Card.Header>
          <Card.Body>
            <Table bordered hover responsive className="mb-3">
              <tbody>
                <tr>
                  <th>Şirket</th>
                  <td>{req.companyName}</td>
                  <th>Kullanıcı</th>
                  <td>{req.userName}</td>
                </tr>
                <tr>
                  <th>Fotoğraf</th>
                  <td className={"text-color-gray-light"}>
                    {req.imageName ? (
                      <Button className={"text-white"} size={"sm"} onClick={() => setSelectedImage(req.imageName)}>
                        Görüntüle
                      </Button>
                    ) : (
                      "Fotoğraf yok"
                    )}
                  </td>
                  <th>Email</th>
                  <td>{req.userEmail}</td>
                </tr>
                <tr>
                  <th>Durum</th>
                  <td>
                    <Form.Check
                      onChange={(e) => HandleUpdateIsResolved(req.id, e.target.checked)}
                      checked={req.isResolved}
                      type="switch"
                      label={req.isResolved ? "Çözüldü" : "Bekliyor"}
                    />
                  </td>
                  <th>Oluşturma Tarihi</th>
                  <td>{new Date(req.creationDate).toLocaleString()}</td>
                </tr>
              </tbody>
            </Table>

            <Row>
              <Col xs={"auto"} className={"align-content-center"}>
                <strong>Başlık:</strong>
              </Col>
              <Col>
                <div className="text-24" style={{ whiteSpace: "pre-wrap" }}>
                  {req.title}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <strong>Konu:</strong>
                <div className="mt-2" style={{ whiteSpace: "pre-wrap" }}>
                  {req.subject}
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};
export default HelpRequests;
